import { useState } from "react";
import ConfigData from "./config.json"; 

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);

  const menuOptions = [
    {
      name: "Data Viewer",
      link: ConfigData.MapViewerURL,
    },
    {
      name: "Use Cases",
      link: ConfigData.SiteURL + "/use-cases",
    },
    {
      name: "Media",  
      link: ConfigData.SiteURL + "/media",
    },
    {
      name: "About",
      link: ConfigData.SiteURL + "/about",
    },
    {
      name: "News",
      link: ConfigData.SiteURL + "/news",
    },
    {
      name: "Contact",
      link: ConfigData.SiteURL + "/contact-us",
    },
  ];

  return (
    <header className="site-header">
      <div className="site-topbar">
        <div className="region region-topbar">
          <a href={ConfigData.SiteURL}>
            <h1>World Heritage Hub</h1>
          </a>
          <ul className="menu">
            {menuOptions.map((option, i) => (
              <li className="menu-item" key={i}>
                <a href={option.link}>{option.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={"site-mobile" + (openMenu ? " menu-open" : "")}>
        <div className="region region-mobile">
          <button className={"hamburger hamburger--collapse" + (openMenu ? " is-active" : "")} type="button" onClick={() => setOpenMenu(prev => !prev)} aria-label="Menu">
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
          <a href={ConfigData.SiteURL}>
            <h1>World Heritage Hub</h1>
          </a>
          <nav role="navigation">
            <ul className="menu">
              {menuOptions.map((option, i) => (
                <li className="menu-item" key={i}>
                  <a href={option.link}>{option.name}</a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
};

export default Header;
